<template>
  <div>
    <!-- <div class="mb-4 py-2 pb-2">
      <div class="bold-24 mb-3">Programmatic Workshops</div>
      <div class="regular-16 ">
        Introductory workshops set the stage and provide the context for the scientific program, with the intended audience being researchers not in the program. This would include members in the other programs, members of the local mathematical community, and participants from outside the area selected especially for the workshop, particularly from groups underrepresented in research intensive contexts: women, minorities, mathematicians not located at research centers, and graduate students. In selecting participants, priority is given to these latter groups.
        <br />
        <br />
        Connections Workshops have a long, successful history of encouraging early-career women and gender-expansive individuals in the profession. Held at the very beginning of semester-long or year-long programs at MSRI, these workshops have three overarching goals: (1) to give accessible introductions to the main themes of the program and exciting new directions in related research; (2) to provide participants the opportunity to become acquainted with the work of women in the field; and (3) to connect early-career researchers, especially women, gender-expansive individuals, and minorities, to potential senior mentors. A typical workshop consists of introductory lectures, presentations by post-doctoral researchers and graduate students, and a panel discussion addressing the challenges faced by all young researchers, but especially by women, in establishing a career in mathematics.
      </div>
    </div> -->

    <div class="mb-2 pb-2">
      <div class="row">
        <div class="col-md-12 mb-3">
          <b-input-group>
            <b-input-group-text slot="prepend" class="bg-shade-1">
              <i class="fa fa-search"></i>
            </b-input-group-text>
            <b-input
              placeholder="Search by name, keyword or mathematical classification number"
              v-model="search"
              autocomplete="off"
              data-lpignore="true"
              @input="filteredSearchProgrammaticWorkshopList(1, null)"
            />
          </b-input-group>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-md-border mb-5">
        <div class="mb-4">
          <div class="lyon-display-medium-24">Current</div>
          <div v-if="loadingProgrammaticWorkshop" >
            <generic-loader />
          </div>
          <div v-else>
            <div v-if="currentProgrammaticWorkshopList.length === 0">
              <span class="text-muted regular-14">No result</span>
            </div>
            <div v-else class="main-content">
              <div v-for="(item, index) in currentProgrammaticWorkshopList" :key="index">
                <div @click="fetchSelectedEvent(item.id, 'programmatic-grid-dtl-id', 'workshops')" class="cursor-pointer">
                  <left-grid-event-list
                    :event-item="item"
                    :active-item-id="activeItemId"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="upcoming-workshop-tab-id" class="mb-4">
          <div class="lyon-display-medium-24">Upcoming</div>
          <div v-if="loadingUpcomingProgrammaticWorkshop || loadingProgrammaticWorkshop" >
            <generic-loader />
          </div>
          <div v-else>
            <div v-if="upcomingProgrammaticWorkshopList.length === 0">
              <span class="text-muted regular-14">No result</span>
            </div>
            <div v-else>
              <div class="main-content">
                <div v-for="(item, index) in upcomingProgrammaticWorkshopList" :key="index">
                  <div @click="fetchSelectedEvent(item.id, 'programmatic-grid-dtl-id', 'workshops')" class="cursor-pointer">
                    <left-grid-event-list
                      :event-item="item"
                      :active-item-id="activeItemId"
                    />
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center flex-shrink-0 mt-3">
                <b-pagination
                  pills
                  :total-rows="upcomingPagination.total_rows"
                  v-model="upcomingCurrentPage"
                  @input="filteredSearchProgrammaticWorkshopList(upcomingCurrentPage, 'upcoming')"
                />
              </div>
            </div>
          </div>
        </div>

        <div id="past-workshop-tab-id">
          <div class="lyon-display-medium-24">Past</div>
          <div v-if="loadingPastProgrammaticWorkshop || loadingProgrammaticWorkshop" >
            <generic-loader />
          </div>
          <div v-else>
            <div v-if="pastProgrammaticWorkshopList.length === 0">
              <span class="text-muted regular-14">No result</span>
            </div>
            <div v-else>
              <div class="main-content">
                <div v-for="(item, index) in pastProgrammaticWorkshopList" :key="index">
                  <div @click="fetchSelectedEvent(item.id, 'programmatic-grid-dtl-id', 'workshops')" class="cursor-pointer">
                    <left-grid-event-list
                      :event-item="item"
                      :active-item-id="activeItemId"
                    />
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center flex-shrink-0 mt-3">
                <b-pagination
                  pills
                  :total-rows="pastPagination.total_rows"
                  v-model="pastCurrentPage"
                  @input="filteredSearchProgrammaticWorkshopList(pastCurrentPage, 'past')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-md-border right-side-program-section" id="programmatic-grid-dtl-id">
        <b-card class="sticky-content" v-if="showDetails">
          <right-grid-event-detail
            :selected-event="selectedEvent"
            :active-item-id="activeItemId"
            :button-name="'VIEW WORKSHOP DETAILS'"
            :page-name="'workshop-details'"
          />
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { scrollToElementId } from '@/utils/CommonUtils.js'
import GenericLoader from '@/components/Loaders/GenericLoader.vue'
import mixin from '@/utils/mixin.js'
import LeftGridEventList from '@/components/CommonPages/LeftGridEventList.vue'
import RightGridEventDetail from '@/components/CommonPages/RightGridEventDetail.vue'
import { mapGetters } from 'vuex'
import debounce from 'lodash/debounce'

export default {
  name: 'ProgrammaticTab',
  components: { GenericLoader, LeftGridEventList, RightGridEventDetail },
  props: ['workshopType'],
  mixins: [mixin],
  data () {
    return {
      search: '',
      selectedEvent: {},
      showDetails: false,
      activeItemId: '',
      currentProgrammaticWorkshopList: [],
      upcomingProgrammaticWorkshopList: [],
      pastProgrammaticWorkshopList: [],
      loadingProgrammaticWorkshop: true,
      upcomingPagination: {},
      upcomingCurrentPage: 1,
      pastPagination: {},
      pastCurrentPage: 1,
      loadingUpcomingProgrammaticWorkshop: false,
      loadingPastProgrammaticWorkshop: false,
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated'])
  },
  watch: {
    isAuthenticated() {
      this.loadProgrammaticWorkshop()
    }
  },
  created () {
    this.loadProgrammaticWorkshop()
  },
  methods: {
    loadProgrammaticWorkshop () {
      this.showDetails = false
      this.$http.get(process.env.VUE_APP_API_URL + '/workshops/programs_workshops', {
        params: {
          search_value: this.search.toLowerCase(),
          page: 1
        }
      })
      .then((res) => {
        this.currentProgrammaticWorkshopList = res.data.programmatic_workshops_current.results
        this.upcomingProgrammaticWorkshopList = res.data.programmatic_workshops_upcoming.results
        this.pastProgrammaticWorkshopList = res.data.programmatic_workshops_past.results
        this.upcomingPagination = res.data.programmatic_workshops_upcoming.pagination
        this.pastPagination = res.data.programmatic_workshops_past.pagination
        this.loadingProgrammaticWorkshop = false
      })
    },
    filteredSearchProgrammaticWorkshopList: debounce(function(pageNumber, val) {
      this.showDetails = false
      if(val === null){
        this.loadingProgrammaticWorkshop = true
        this.pastCurrentPage = 1
        this.upcomingCurrentPage = 1
        scrollToElementId('workshop-tab-id')
      } else if(val === 'upcoming') {
        this.loadingUpcomingProgrammaticWorkshop = true
        scrollToElementId('upcoming-workshop-tab-id')

      } else if(val === 'past') {
        this.loadingPastProgrammaticWorkshop = true
        scrollToElementId('past-workshop-tab-id')
      }
      const searchValue = this.search.toLowerCase();
      this.$http.get(process.env.VUE_APP_API_URL + '/workshops/programs_workshops', {
      params: {
        search_value: searchValue,
        page: pageNumber,
      }
      })
      .then((res) => {
        if(val === null) {
          this.currentProgrammaticWorkshopList = res.data.programmatic_workshops_current.results
          this.upcomingProgrammaticWorkshopList = res.data.programmatic_workshops_upcoming.results
          this.pastProgrammaticWorkshopList = res.data.programmatic_workshops_past.results
          this.upcomingPagination = res.data.programmatic_workshops_upcoming.pagination
          this.pastPagination = res.data.programmatic_workshops_past.pagination
          this.loadingProgrammaticWorkshop = false
        } else if(val === 'upcoming') {
          this.upcomingProgrammaticWorkshopList = res.data.programmatic_workshops_upcoming.results
          this.upcomingPagination = res.data.programmatic_workshops_upcoming.pagination
          this.loadingUpcomingProgrammaticWorkshop = false
        } else if(val === 'past') {
          this.pastProgrammaticWorkshopList = res.data.programmatic_workshops_past.results
          this.pastPagination = res.data.programmatic_workshops_past.pagination
          this.loadingPastProgrammaticWorkshop = false
        }
      })
    }, 800)
  }
}
</script>
